/**
 * Opération « montant minimum » — compteur panier.
 *
 * Le bundle Aurora (compilé, sources absentes du repo) met le panier à jour
 * sans nous prévenir. Plutôt que de patcher le bundle ou fetch(), on observe
 * les requêtes réseau terminées (PerformanceObserver) : toute requête vers
 * /cart/add|change|update|clear déclenche une relecture de /cart.js.
 */
(() => {
  if (customElements.get('threshold-cart-counter')) return;

  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const counters = new Set();
  let pending = null;
  let again = false;

  const formatMoney = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(cents / 100);

  const eligibleAmount = (cart) =>
    cart.items.reduce(
      (total, item) => (item.gift_card ? total - item.final_line_price : total),
      cart.total_price,
    );

  const refreshAll = () => {
    if (pending) {
      again = true; // une mutation terminée pendant le fetch : on relit ensuite
      return pending;
    }
    pending = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => counters.forEach((counter) => counter.render(eligibleAmount(cart))))
      .catch(() => {}) // le rendu Liquid initial reste affiché
      .finally(() => {
        pending = null;
        if (again) {
          again = false;
          refreshAll();
        }
      });
    return pending;
  };

  if ('PerformanceObserver' in window) {
    new PerformanceObserver((list) => {
      if (list.getEntries().some((entry) => CART_MUTATION.test(entry.name))) refreshAll();
    }).observe({ type: 'resource', buffered: false });
  }

  class ThresholdCartCounter extends HTMLElement {
    connectedCallback() {
      counters.add(this);
      refreshAll(); // le tiroir est monté après l'ajout : relire le panier à chaque montage
    }

    disconnectedCallback() {
      counters.delete(this);
    }

    render(amount) {
      const threshold = Number(this.dataset.threshold);
      const remaining = threshold - amount;
      const achieved = remaining <= 0;
      const progress = Math.max(0, Math.min(100, (amount / threshold) * 100));

      this.dataset.achieved = String(achieved);
      this.style.setProperty('--threshold-progress', `${progress}%`);
      this.querySelector('[data-threshold-message]').textContent = achieved
        ? this.dataset.achievedMessage
        : this.dataset.progressMessage.replaceAll('[amount]', formatMoney(remaining));
    }
  }

  customElements.define('threshold-cart-counter', ThresholdCartCounter);
})();
